import { isEmail, isMobilePhone } from 'validator';

export default (question, answer, language = 'nl') => {
  const { allowEmpty, validator } = question;
  if (!allowEmpty && answer.length === 0) {
    throw new Error(language === 'nl' ? 'Dit veld mag niet worden leeggelaten.' : 'This field cannot be empty.');
  }
  if (validator === 'EMAIL' && !isEmail(answer))
    throw new Error(language === 'nl' ? 'Vul een geldig e-mailadres in.' : 'Please enter a valid email address.');
  if (validator === 'PHONE' && !isMobilePhone(answer))
    throw new Error(language === 'nl' ? 'Vul een geldig telefoonnummer in.' : 'Please enter a valid phone number.');
  if (validator === 'NOSPECIALCHARS' && !answer.match(/^([a-zA-Z0-9 _-]+)$/)) {
    throw new Error(language === 'nl' ? 'Geen speciale karakters toegestaan (alleen - _ )' : 'No special characters allowed (only - _ )');
  }
  return answer;
};
